module.exports = __webpack_public_path__ + "img/weibo.ae13b4d.svg";